import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../Components/Layout';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import EyeOpenIco from "../Components/Images/eye.svg";
import EyeCloseIco from "../Components/Images/eye-slash.svg";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { PostApiWithoutLogin } from '../apiService';
import { API_PATH, imp_data } from '../const';
import Loader from '../Components/Layout/Loader';

function VerifyUser(props) {
    
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [showPassword, setshowPassword] = useState("password");
    const [showPassword2, setshowPassword2] = useState("password");
    const [submit_status, set_submit_status] = useState(false);
    const [loader, set_loader] = useState(false);
    
    const { 
        register, 
        handleSubmit, 
        getValues,
        reset,
        formState: { errors }, 
    } = useForm();

    const onSubmit = useCallback(() => {
        set_loader(true);
        const data = getValues();
        if(data.password === data.password2) {
            delete data.password2;
            data.token = searchParams.get("token");
            const SumbitInquiryForm = Promise.resolve(PostApiWithoutLogin(API_PATH.VerifyUserRoute, data));
            SumbitInquiryForm.then(response => {
                if(response.status === 200){
                    if(response.data?.data?.token !== "") {
                        const jwt_token = "Bearer " + response.data?.data?.token
                        localStorage.setItem('PPKTOKEN', jwt_token);
                        const user_info = response.data?.data?.user_info ?? {};
                        if(user_info.type === 2) PaymentForFounder({
                            user_id: user_info.id ?? 0,
                            amount: imp_data.FounderPayment,
                            reason: 1
                        })
                        else navigate('/advertisements', { state: { jwt_token } })
                        reset();
                    } else toast.error("Server error, try again later!")
                } else toast.error("Token expired, try again!");
                set_loader(false);
            })
        } else{
            toast.error("Passwords are not matching please try again");
            set_loader(false);
        }
    }, [getValues]); 

    const PaymentForFounder = (data) => {
        set_loader(true);
        const PaymentInitation = Promise.resolve(PostApiWithoutLogin(API_PATH.PaymentInit, data));
        PaymentInitation.then(response => {
            const payment_url = response.data?.data?.checkoutPageUrl ?? "";
            if(payment_url !== "") window.location.href = payment_url; 
            else toast.error("Could not generate payment url please try again later.")
        })
    }

    return (
        <Layout>
            {loader === true ? <Loader text={"Verifying..."}></Loader> : <></>}
            <section className='common-space-both container pt-4'>
                <div className="sign-form-cust mt-4">
                    <h1 className="text-center">Set Up New Password</h1>
                    {/* <p className="text-center">{type === 2 ? "Join and be the part of Poppk.in" : "Create your free account now and start uploading your ads"}</p> */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row me-0">
                            <div className="col-12 pe-0 mb-2 pb-1">
                                <label className="lbl-info-common">Password</label>
                                <div className="position-relative login-icons-div">
                                    <input 
                                        type={showPassword} 
                                        className="form-control form-style-input" 
                                        placeholder="Enter your password" 
                                        name="password" 
                                        {...register("password", { required: "Please enter the password" })}
                                    />
                                    <div className="eyes-icons-div">
                                        <img
                                            src={showPassword === "password" ? EyeCloseIco : EyeOpenIco}
                                            loading="lazy"
                                            alt="Password"
                                            className="img-fluid"
                                            onClick={() => setshowPassword(showPassword === "password" ? "text" : "password")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 pe-0 mb-2 pb-1">
                                <label className="lbl-info-common">Confirm Password</label>
                                <div className="position-relative login-icons-div">
                                    <input 
                                        type={showPassword2} 
                                        className="form-control form-style-input" 
                                        placeholder="Enter your confirm password" 
                                        name="password" 
                                        {...register("password2", { required: "Please re-enter the password" })}
                                    />
                                    <div className="eyes-icons-div">
                                        <img
                                            src={showPassword2 === "password2" ? EyeCloseIco : EyeOpenIco}
                                            loading="lazy"
                                            alt="Password"
                                            className="img-fluid"
                                            onClick={() => setshowPassword2(showPassword2 === "password" ? "text" : "password")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-2">
                            <button className="btn-all-comn w-100" type="submit">
                                Let Get Started
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </Layout>
    );
}

export default VerifyUser;